// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zfH3","rootMobile":"styles_rootMobile__1qr0a"};